const doc = [({"en":({"js":({"nemoa":({"layout":({"top_menu":({"user_menu_item":({"index":({"account":"Account", "sign_out":"Sign out"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;